export const ADD_POPUP = "ADD_POPUP";
export const GET_POPUP = "GET_POPUP";